import { render, staticRenderFns } from "./Prompt.vue?vue&type=template&id=85101de8&scoped=true"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"
import style0 from "./Prompt.vue?vue&type=style&index=0&id=85101de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85101de8",
  null
  
)

export default component.exports